import React from 'react'

const SavedCard = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="18"
            viewBox="0 0 24 18"
        >
            <g
                fill="none"
                fillRule="evenodd"
                stroke="none"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
            >
                <g stroke="currentColor" transform="translate(-102 -611)">
                    <g transform="translate(-1)">
                        <g transform="translate(83 107)">
                            <g transform="translate(21 505)">
                                <g strokeWidth="2">
                                    <rect
                                        width="22"
                                        height="16"
                                        x="0"
                                        y="0"
                                        rx="2"
                                    />
                                    <path d="M0 6L22 6" />
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    )
}

export default React.memo(SavedCard)
